/**
 * In this file use to contains the physician Module Development screen UI and Logic
 **/
import { Link } from "react-router-dom";
import { goBack } from "./../../../services/UtilsService";
import { useState, useEffect } from "react";
import ApiService from "./../../../services/ApiService";
import Pagination from "./../../../shared/components/Pagination";
import {
  convertDOBtoAge,
  convertDOBtoAgerangeId,
  convertDOBtoDevStage,
  convertS3privateToPublic,
} from "./../../../services/UtilsService";
import DevelopmentModal from "./../../../shared/modals/DevelopmentModal";
import { useTranslation } from 'react-i18next';

function Development() {
  //Intial state declaraction
  const [developmentList, setDevelopmentList] = useState([]);
  const [param, setParam] = useState({ page: 0, limit: 10 });
  const [show, setShow] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  /**
   * To handle pagination event
   * @data we pass the page count
   **/
  const handlePaginate = (data) => {
    setParam({ ...param, page: data });
  };

  //callback function
  const handleClose = () => setShow(false);

  /**
   *handeonChange while search
   * @e we get the event Details from the change event
   **/
  const handleChange = async (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setParam({ ...param, [name]: value, page: 0 });
  };

  /**
   *handeonChange while dropdown change
   * @e we get the event Details from the onchange event
   **/
  const handleSortChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setParam({ ...param, [name]: value });
  };

  //Component Initialize function
  useEffect(() => {
	const fetchData = async () => {
		setIsLoading(true); 
		try {
			const response = await ApiService.listDevelopmentMember(param);
			if (response.status === 200) {
				setDevelopmentList(response.data);
			}
		} catch (error) {
			console.error('Error fetching member development data:', error);
		} finally {
			setIsLoading(false); 
		}
	};
	fetchData();
  }, [param]);

  return (
    <>
      <main id="main" className="main">
        {/*Import DevelopmentModal*/}
        {Object.keys(show).length !== 0 && (
          <DevelopmentModal data={show} handleClose={handleClose} />
        )}
        <div className="pagetitle clearfix">
          <div className="float-start">
            <h1>{t('sidebar.development')}</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/physician/dashboard">
                    {t('sidebar.home')}
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  {t('sidebar.development')}{" "}
                </li>
              </ol>
            </nav>
          </div>
          <div className="float-end mt-2 me-1">
            <span onClick={goBack} className="backIcon">
              <i className="iconly-Bold-ArrowLeftSquare"></i>
            </span>
          </div>
        </div>
        {/*Page Content Section*/}
        <section className="pagesection">
          {/*Search*/}
          <div className="row my-3">
            <div className="col-xxl-7 col-lg-7 d-flex">
              <div className="input-group input-group-sm me-2 w-50">
                <input
                  type="text"
                  name="search"
                  value={param.search ? param.search : ""}
                  onChange={handleChange}
                  className="form-control"
                  placeholder={t('common.search')}
                />
                <button className="btn btn-tmBlue" type="button">
                  <i className="ri-search-line"></i>
                </button>
              </div>
            </div>
            {/*End Search*/}

            <div className="col-xxl-5 col-lg-5">
              {/*<Link
                to="/physician/add-development"
                className="btn btn-sm btn-outline-tmBlue float-end"
              >
                <i className="iconly-Bold-Plus align-middle me-1"></i>{" "}
                {t('common.addDevelopment')}
			        </Link>*/}
              {/* Sort */}
              <div className="dropdown float-end me-3">
                <a
                  className="btn btn-sm btn-outline-tmBlue dropdown-toggle"
                  href="javascript;"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {" "}
                  {t('common.sort')}{" "}
                </a>

                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuLink"
                >
                  <li>
                    <button
                      className={
                        param.sort === "added"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      type="button"
                      value="added"
                      name="sort"
                      onClick={handleSortChange}
                    >
                      {" "}
                      {t('common.recentAdded')}{" "}
                    </button>
                  </li>
                  <li>
                    <button
                      className={
                        param.sort === "updated"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      type="button"
                      value="updated"
                      name="sort"
                      onClick={handleSortChange}
                    >
                      {" "}
                      {t('common.recentUpdated')}{" "}
                    </button>
                  </li>
                </ul>
              </div>
              {/*End Sort*/}
            </div>
          </div>

          {/*Table*/}
          <div className="row my-3">
            <div className="col-xxl-12">
              <div className="table-responsive">
                <table className="table table-borderless theme-table">
                  <thead>
                    <tr>
                      <th width={250}>
                        {t('table.memberDetails')}
                      </th>
                      <th>{t('table.developmentMonth')}</th>
                      <th>{t('table.developmentalMilestones')}</th>
                      <th className="text-center">
                        {t('table.developmentChart')}
                      </th>
                      <th className="text-center">
                        {t('table.add')}
                      </th>
                    </tr>
                  </thead>
                  {developmentList && developmentList?.items?.length ? (
                    <tbody>
                      {developmentList.items.map((item, i) => (
                        <tr
                          key={i}
                          className={item?.gender === 0 ? "male" : "female"}
                        >
                          <td>
                            <div className="d-flex align-items-center ps-1">
                              <div className="avtar-img">
                                <span className="rounded-circle">
                                  {item?.photo === "default.png" ? (
                                    <img
                                      src="/assets/img/user-avatar.png"
                                      alt="UN"
                                    />
                                  ) : (
                                    <img
                                      src={convertS3privateToPublic(
                                        item?.photo
                                      )}
                                      alt="UN"
                                    />
                                  )}
                                </span>
                              </div>
                              <div className="ms-3">
                                <Link
                                  to={
                                    "/physician/member-profile/" + item?.member
                                  }
                                >
                                  <h5 className="table-title fw-bold text-capitalize">
                                    {item?.name}
                                  </h5>
                                </Link>
                                <p className="table-subtitle">
                                  <span>
                                    {item.gender === 0 ? t('common.boy') :  t('common.girl')}
                                  </span>{" "}
                                  - {convertDOBtoAge(item.dob, t)}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>{convertDOBtoDevStage(item.dob,t)}</td>
                          {/* Developmental Milestones */}
                          <td className="align-middle h6">
                            {(() => {
                              const ageRange = convertDOBtoAgerangeId(item.dob);
                              // Convert item.age_range_array to a Set to remove duplicates and convert back to an array
                              const ageArray = [
                                ...new Set(item.age_range_array?.map(Number)),
                              ];
                              const requiredAges = Array.from(
                                { length: ageRange === 0 ? 10 : ageRange },
                                (_, i) => i + 1
                              ).slice(0, ageRange === 0 ? 10 : ageRange === 1 ? 1 : ageRange - 1);
                              const containsAllRequiredAges =
                                requiredAges.every((age) =>
                                  ageArray.includes(age)
                                );
                              if (containsAllRequiredAges) {
                                return (
                                  <span className="text-tmGreen">
                                    <i className="fa-solid fa-check ms-1" />
                                    {t('common.completed')}
                                  </span>
                                );
                              } else {
                                return (
                                  <span className="text-danger">
                                    <i className="fa-solid fa-xmark ms-1" />
                                    {t('common.notCompleted')}
                                  </span>
                                );
                              }
                            })()}
                          </td>
                          <td className="text-center">
                            <span
                              className="table-link text-tmBlue"
                              onClick={() =>
                                setShow({
                                  development: true,
                                  id: item.member,
                                  parent: item.parent,
                                  name: item.name,
                                })
                              }
                            >
                              {" "}
                              <i className="fa-solid fa-chart-column" />
                            </span>
                          </td>
                          <td className="text-center">
                            <Link
                              to={"/physician/add-development/" + item?.member}
                              className="table-link text-tmBlue"
                            >
                              <i className="ri-add-box-fill align-middle fw-normal"></i>{" "}
                            </Link>{" "}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
				  !isLoading &&
                    <tbody>
                      <tr>
                        <td colSpan="11" className="text-center">
                          {t('common.noRecord')}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
          {/*End Table*/}
          {/*Pagination*/}
          {developmentList &&
            developmentList.length !== 0 &&
            developmentList?.items?.length !== 0 && (
              <div className="row my-3">
                <div className="col-xxl-12 d-flex justify-content-center">
                  <Pagination
                    page={param.page}
                    handlePaginate={handlePaginate}
                    total={developmentList.count}
                  />
                </div>
              </div>
            )}
          {/*End Pagination*/}
        </section>
        {/*End Page Content Section*/}
      </main>
    </>
  );
}

export default Development;
